export default {"src":"/_next/static/media/icon_more_support.ac6c4727.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};